import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { RemovePositionDialog } from "@/routes/_layout/settings/_panel/-components/remove-position-dialog"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/teams/_list/$teamId/positions/$positionId/remove",
)({
  component: RemovePosition,
})

function RemovePosition(): React.ReactElement {
  const { teamId, positionId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({
      to: "/settings/workspace/teams/$teamId",
      params: { teamId },
      search: true,
    })

  return (
    <RemovePositionDialog
      owner={{ team_id: teamId }}
      positionId={positionId}
      onRemoved={(removed) => {
        showToast("Removed", `${removed.name} removed.`, "success")
        close()
      }}
      onClose={close}
    />
  )
}
